<template>
  <div class="wrap">
    <img
      src="@/assets/icons/promo-full.svg"
      class="logo"
      alt="promo.ai"
    >

    <h1 class="mt-4 mb-6 text-center leading-normal text-lg md:text-xl lg:text-2xl text-support-light">
      We're creating your templates, sit tight!
    </h1>

    <Loader label="Generating templates..." />
  </div>
</template>

<script>
import Loader from "@/components/UI/Loader";

export default {
  name: "Step4",
  components: { Loader },
  mounted() {
    this.$emit("complete-onboarding");
  }
};
</script>

<style scoped>
.wrap {
  @apply bg-white p-6;
  border-radius: 10px;

  @screen md {
    @apply p-10;
  }
}

.loading-icon {
  @apply mx-auto my-10 block;
}

.logo {
  @apply block mx-auto mb-10;
  width: 250px;
}
</style>
